import { render, staticRenderFns } from "./section_library_permissions.vue?vue&type=template&id=09fbd392&scoped=true&"
import script from "./section_library_permissions.vue?vue&type=script&lang=js&"
export * from "./section_library_permissions.vue?vue&type=script&lang=js&"
import style0 from "./section_library_permissions.vue?vue&type=style&index=0&id=09fbd392&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbd392",
  null
  
)

export default component.exports